import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { SysLogDTO } from '../../../api/sys-log-api';
import { UserDTO } from '../../../api/user-api';
import SvgClose from '../../../assets/icons/Close';
import SvgDelete from '../../../assets/icons/Delete';
import SvgSave from '../../../assets/icons/Save';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';

interface SaveSysLogModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedSysLog?: SysLogDTO;
    users: UserDTO[];
    onHide: () => void;
    onSave: (values: SysLogDTO) => void;
    onDelete?: (sysLog: SysLogDTO) => void;
}

export function SaveSysLogModal({
    show,
    allowEdit,
    selectedSysLog,
    users,
    onHide,
    onSave,
    onDelete,
}: SaveSysLogModalProps) {
    const SysLogSchema = yup.object().shape({
        type: yup.string(),
        message: yup.string(),
        displayMessage: yup.string(),
        details: yup.string(),
        url: yup.string(),
        queryString: yup.string(),
        properties: yup.string(),
        sessionId: yup.number(),
        token: yup.string(),
        userName: yup.string(),
    });

    const defaultValues: SysLogDTO = {
        serial: selectedSysLog?.serial,

        type: selectedSysLog ? selectedSysLog.type : '',
        message: selectedSysLog ? selectedSysLog.message : '',
        displayMessage: selectedSysLog ? selectedSysLog.displayMessage : '',
        details: selectedSysLog ? selectedSysLog.details : '',
        url: selectedSysLog ? selectedSysLog.url : '',
        queryString: selectedSysLog ? selectedSysLog.queryString : '',
        properties: selectedSysLog ? selectedSysLog.properties : '',
        sessionId: selectedSysLog ? selectedSysLog.sessionId : 0,
        token: selectedSysLog ? selectedSysLog.token : '',
        userName: selectedSysLog ? selectedSysLog.userName : '',
    };

    if (!show) return <></>;

    return (
        <Formik initialValues={defaultValues} validationSchema={SysLogSchema} onSubmit={onSave}>
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    size="xl"
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedSysLog ? 'edit-sys-log' : 'new-sys-log'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedSysLog && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedSysLog)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="type"
                                name="type"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="message"
                                name="message"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="display-message"
                                name="displayMessage"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="details"
                                name="details"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="url"
                                name="url"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="query-string"
                                name="queryString"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="properties"
                                name="properties"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="session-id"
                                name="sessionId"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="token"
                                name="token"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="user-name"
                                name="userName"
                                readOnly={!allowEdit}
                                type="select"
                                items={[
                                    { id: null, title: '' },
                                    ...users.map(user => ({
                                        id: user.userName,
                                        title: `${user.firstName} ${user.lastName} `,
                                    })),
                                ]}
                                width="11rem"
                                handleEnter
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
